import { NativeStackHeaderItem } from '@react-navigation/native-stack'

type Args = {
  onPress: () => void
}

export default function closeButton({ onPress }: Args): NativeStackHeaderItem {
  return {
    type: 'button',
    label: '关闭',
    icon: {
      name: 'xmark',
      type: 'sfSymbol',
    },
    onPress,
  }
}
